import { useTranslation } from 'react-i18next'
import { Zap } from 'lucide-react'

interface ManualAuditSettingsProps {
  error: Error | null
  canSubmit: boolean
  isPending: boolean
  onSubmit: () => void
}

export function ManualAuditSettings({
  error, canSubmit, isPending, onSubmit,
}: ManualAuditSettingsProps) {
  const { t } = useTranslation()

  return (
    <>
      {error && (
        <div className="p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg text-sm text-red-600 dark:text-red-400">
          {t('amazonListing.errors.failed')}
        </div>
      )}
      <div className="flex items-center justify-between pt-2">
        <span className="text-sm text-neutral-500">{t('amazonListing.creditsRequired')}</span>
        <button onClick={onSubmit} disabled={!canSubmit}
          className="flex items-center gap-2 px-5 py-2.5 bg-orange-500 hover:bg-orange-600 disabled:bg-neutral-300 dark:disabled:bg-neutral-600 text-white rounded-lg font-medium transition-colors">
          <Zap className="h-4 w-4" />
          {isPending ? t('common.loading') : t('amazonListing.manual.startAnalysis')}
        </button>
      </div>
    </>
  )
}
